import { useQuery } from '@apollo/client/react';
import SelectField from './select-field';
import { cityFieldCitiesQuery } from '../../apollo/cities';

type Props = {
  name: string;
  valueAttribute?: string;
  allowNull?: boolean;
  [key: string]: unknown;
};

const CityField = ({ name, valueAttribute = 'id', allowNull = false, ...otherProps }: Props) => {
  const { data } = useQuery(cityFieldCitiesQuery);
  const cities = data?.cities || [];
  const options = cities.map((city) => ({
    value: city[valueAttribute],
    label: city.name
  }));
  if (allowNull) {
    options.unshift({
      value: null,
      label: 'No City'
    });
  }

  return (
    <SelectField
      name={name}
      {...otherProps}
      options={options}
    />
  );
};

export default CityField;
